import Button from "@mui/material/Button"
import { alpha, useTheme } from "@mui/material/styles"

interface GoogleLoginButtonProps
{
  onClick: () => void
  text: string
  disabled: boolean
}

export const GoogleLoginButton = ({ onClick, text, disabled }: GoogleLoginButtonProps) => {
  const theme = useTheme()
  return (<Button
    fullWidth
    disabled={disabled}
    onClick={onClick}
    variant="outlined"
    sx={styles.button(theme)}>
    <img src={require("../assets/google.png")} style={styles.icon}/>
    {text}
  </Button>)
}

const styles = {
  button: (theme: any) => ({
    minHeight: 48,
    borderRadius: "14px",
    justifyContent: "center",
    gap: 2,
    borderColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.45),
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.68),
  }),
  icon: {
    objectFit: "contain" as "contain",
    width: 25,
    height: 25,
    marginRight: 2,
  }
}
